import React from 'react';
import IssuesStep1 from './IssuesStep1';

export default function Step1Conatiner({ formikProps, data }) {
  return <IssuesStep1 formikProps={formikProps} data={data} />;
}
